import { render, staticRenderFns } from "./UserMaster.vue?vue&type=template&id=47b40aae&scoped=true&"
import script from "./UserMaster.vue?vue&type=script&lang=js&"
export * from "./UserMaster.vue?vue&type=script&lang=js&"
import style0 from "./UserMaster.vue?vue&type=style&index=0&id=47b40aae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b40aae",
  null
  
)

export default component.exports